export { default as Wishlist } from './Wishlist';
